var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowHead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3235_2848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2849 28.3593L7.81488 27.3893C6.98488 27.2893 6.21488 26.8993 5.65488 26.2793L4.59488 25.0993C4.08488 24.5293 3.77488 23.8093 3.72488 23.0493L3.00488 12.9793C2.92488 11.8593 3.39488 10.7793 4.26488 10.0693L7.24488 7.64934C7.62488 7.33934 8.06488 7.11934 8.53488 6.98934L15.4449 5.16934C15.9149 5.04934 16.4049 5.01934 16.8849 5.09934L22.2449 5.98934C22.5649 6.03934 22.8849 6.13934 23.1849 6.28934L27.6049 8.43934C28.7849 9.00934 29.5349 10.2093 29.5349 11.5293V12.6393L29.3649 17.6093C29.3649 17.7893 29.3349 17.9593 29.3049 18.1393L28.2049 23.8793C28.0449 24.6993 27.5949 25.4393 26.9249 25.9493L25.2549 27.2393C24.7149 27.6493 24.0649 27.8993 23.3849 27.9393L16.9249 28.3693C16.7149 28.3793 16.5149 28.3693 16.3049 28.3593H16.2849Z",
    fill: "url(#paint0_linear_3235_2848)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0452 13.9584L29.8152 13.6284C29.9152 13.6084 30.0052 13.6784 30.0152 13.7784L29.8152 19.6784C29.8152 19.7384 29.7852 19.7984 29.7352 19.8284L28.4352 20.5884C28.4352 20.5884 28.3452 20.6184 28.2952 20.5984L26.6452 20.0184C26.5752 19.9984 26.5352 19.9284 26.5352 19.8584L26.9052 14.1184C26.9052 14.0484 26.9652 13.9884 27.0352 13.9684L27.0452 13.9584Z",
    fill: "url(#paint1_linear_3235_2848)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.345 14.0483L2.575 13.7183C2.475 13.6983 2.385 13.7683 2.375 13.8683L2.575 19.7683C2.575 19.8283 2.605 19.8883 2.655 19.9183L3.955 20.6783C3.955 20.6783 4.045 20.7083 4.095 20.6883L5.745 20.1083C5.815 20.0883 5.855 20.0183 5.855 19.9483L5.485 14.2083C5.485 14.1383 5.425 14.0783 5.355 14.0583L5.345 14.0483Z",
    fill: "url(#paint2_linear_3235_2848)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1051 11.7383H8.63508C6.46508 11.7383 4.70508 13.4983 4.70508 15.6683V20.1483C4.70508 22.9883 6.28508 25.5783 8.80508 26.8783L12.6251 28.8483C14.8051 29.9783 17.3951 29.9783 19.5851 28.8483L23.4051 26.8783C25.9251 25.5783 27.5051 22.9783 27.5051 20.1483V15.6683C27.5051 13.4983 25.7451 11.7383 23.5751 11.7383H16.1051Z",
    fill: "url(#paint3_linear_3235_2848)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7743 21.5586C15.2943 21.6686 16.4043 21.8486 17.3643 21.6186C17.4743 21.5886 17.5443 21.7186 17.4643 21.7986C17.0843 22.1786 16.4343 22.7886 16.1243 22.8986C15.7843 23.0186 15.0243 22.1686 14.6743 21.7386C14.6143 21.6586 14.6743 21.5486 14.7743 21.5686V21.5586Z",
    fill: "url(#paint4_linear_3235_2848)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 24.4883C14.625 24.4883 16.845 25.1983 17.745 24.4883C17.745 24.4883 17.135 25.6083 16.185 25.6083C15.235 25.6083 14.625 24.4883 14.625 24.4883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75555 9.80838L2.89555 10.0684C2.67555 10.0984 2.46555 9.93838 2.43555 9.71838L2.31555 8.88838C2.28555 8.66838 2.44555 8.45838 2.66555 8.42838L3.79555 8.26838L1.74555 7.36838C1.55555 7.28838 1.45555 7.07838 1.51555 6.87838L1.69555 6.23838C1.76555 5.99838 2.02555 5.87838 2.24555 5.96838L3.54555 6.50838L0.445547 3.69838C0.265547 3.53838 0.265547 3.25838 0.445547 3.08838L1.28555 2.30838C1.46555 2.13838 1.75555 2.16838 1.89555 2.37838L4.29555 5.79838L2.94555 1.78838C2.88555 1.59838 2.96555 1.39838 3.13555 1.29838L3.80555 0.918381C4.03555 0.788381 4.33555 0.918381 4.40555 1.16838L5.38555 4.80838L5.41555 2.58838C5.41555 2.33838 5.64555 2.14838 5.89555 2.18838L6.78555 2.32838C7.01555 2.36838 7.16555 2.58838 7.12555 2.80838L6.72555 4.91838L7.99555 3.76838C8.12555 3.64838 8.31555 3.62838 8.46555 3.70838L8.97555 3.98838C9.13555 4.07838 9.21555 4.25838 9.17555 4.42838L8.92555 6.86838L4.75555 9.78838V9.80838Z",
    fill: "#F56F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0039 9.33768L28.8739 9.80768L29.4439 8.42768C29.4739 8.20768 29.3139 7.99768 29.0939 7.96768L27.9639 7.80768L30.0139 6.90768C30.2039 6.82768 30.3039 6.61768 30.2439 6.41768L30.0639 5.77768C29.9939 5.53768 29.7339 5.41768 29.5139 5.50768L28.2139 6.04768L31.3239 3.23768C31.5039 3.07768 31.5039 2.79768 31.3239 2.62768L30.4839 1.84768C30.3039 1.67768 30.0139 1.70768 29.8739 1.91768L27.4739 5.33768L28.8339 1.31768C28.8939 1.12768 28.8139 0.927678 28.6439 0.827678L27.9739 0.447678C27.7439 0.317678 27.4439 0.447678 27.3739 0.697678L26.3939 4.33768L26.3639 2.11768C26.3639 1.86768 26.1339 1.67768 25.8839 1.71768L24.9939 1.85768C24.7639 1.89768 24.6139 2.11768 24.6539 2.33768L25.0539 4.44768L23.7839 3.29768C23.6539 3.17768 23.4639 3.15768 23.3139 3.23768L22.8039 3.51768C22.6439 3.60768 22.5639 3.78768 22.6039 3.95768V6.35768L27.0239 9.31768L27.0039 9.33768Z",
    fill: "#F56F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75508 9.80859L4.70508 19.7686L6.03508 13.2086L12.8851 13.6286L13.2051 12.4086L13.7851 13.7186H25.9851L26.5451 12.4086L26.6551 20.0186L28.2851 10.1286L4.75508 9.80859Z",
    fill: "#F56F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2949 19.9777C17.2949 19.9777 19.4749 16.9877 21.8449 16.8877C24.2149 16.7877 25.2149 19.2777 25.2149 19.2777C25.2149 19.2777 23.3649 21.0777 21.2549 21.0677C19.1449 21.0677 17.2949 19.9677 17.2949 19.9677V19.9777Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2548 19.249C22.0048 19.249 22.6048 18.639 22.6048 17.899C22.6048 17.499 22.4348 17.149 22.1548 16.899C22.0548 16.899 21.9448 16.889 21.8348 16.899C21.1748 16.929 20.5348 17.179 19.9448 17.519C19.9048 17.639 19.8848 17.769 19.8848 17.899C19.8848 18.649 20.4948 19.249 21.2348 19.249H21.2548Z",
    fill: "#668757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8449 17.1779C23.8049 17.0979 24.8149 18.7679 25.1149 19.3579C25.1749 19.3079 25.2149 19.2679 25.2149 19.2679C25.2149 19.2679 24.2149 16.7779 21.8449 16.8779C19.4749 16.9779 17.2949 19.9679 17.2949 19.9679C17.2949 19.9679 17.3549 19.9979 17.4549 20.0579C17.9949 19.3779 19.8549 17.2579 21.8449 17.1779Z",
    fill: "#F56F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1141 16.199C17.9041 16.239 17.7441 16.419 17.7441 16.629V17.049L20.8941 16.179C20.8941 16.179 20.9741 16.159 21.0141 16.159L23.8941 16.209C24.0041 16.209 24.1041 16.249 24.1841 16.319L25.6641 17.629L24.2841 15.879C24.2041 15.769 24.0741 15.709 23.9341 15.709H20.9341C20.9341 15.709 20.8841 15.709 20.8641 15.709L18.1041 16.179L18.1141 16.199Z",
    fill: "#F56F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8751 19.9777C14.8751 19.9777 12.6951 16.9877 10.3251 16.8877C7.95508 16.7877 6.95508 19.2777 6.95508 19.2777C6.95508 19.2777 8.80508 21.0777 10.9151 21.0677C13.0251 21.0677 14.8751 19.9677 14.8751 19.9677V19.9777Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9145 19.249C10.1645 19.249 9.56445 18.639 9.56445 17.899C9.56445 17.499 9.73445 17.149 10.0145 16.899C10.1145 16.899 10.2245 16.889 10.3345 16.899C10.9945 16.929 11.6345 17.179 12.2245 17.519C12.2645 17.639 12.2845 17.769 12.2845 17.899C12.2845 18.649 11.6745 19.249 10.9345 19.249H10.9145Z",
    fill: "#668757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3251 17.1779C8.36508 17.0979 7.35508 18.7679 7.05508 19.3579C6.99508 19.3079 6.95508 19.2679 6.95508 19.2679C6.95508 19.2679 7.95508 16.7779 10.3251 16.8779C12.6951 16.9779 14.8751 19.9679 14.8751 19.9679C14.8751 19.9679 14.8151 19.9979 14.7151 20.0579C14.1751 19.3779 12.3151 17.2579 10.3251 17.1779Z",
    fill: "#F56F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9256 16.1783C14.2156 16.2283 14.4356 16.4783 14.4356 16.7783V17.0583L11.3156 16.1983C11.2556 16.1783 11.2056 16.1783 11.1456 16.1783L8.34562 16.2283C8.19562 16.2283 8.05562 16.2883 7.94562 16.3783L6.51562 17.6483L7.84562 15.9683C7.96562 15.8183 8.13563 15.7383 8.32563 15.7383H11.2256C11.2256 15.7383 11.2956 15.7383 11.3256 15.7383L13.9256 16.1783Z",
    fill: "#F56F51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3235_2848",
    x1: 16.3749,
    y1: 6.30934,
    x2: 15.9049,
    y2: 29.4693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F56F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F47053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F2765B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F08069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EC8D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E79F97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E6A59F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3235_2848",
    x1: 28.4152,
    y1: 12.6784,
    x2: 28.1652,
    y2: 20.3884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F9B3B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F3D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F1DCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1DFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3235_2848",
    x1: 3.925,
    y1: 12.7683,
    x2: 4.235,
    y2: 20.6283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F9B3B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F3D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F1DCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1DFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3235_2848",
    x1: 16.1051,
    y1: 8.88828,
    x2: 16.1051,
    y2: 26.0883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F9B3B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F3D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F1DCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1DFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3235_2848",
    x1: 16.1343,
    y1: 23.2486,
    x2: 16.0443,
    y2: 20.9686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F9B3B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F3D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F1DCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1DFE0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3235_2848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.15,
    height: 29.3,
    fill: "white",
    transform: "translate(0.304688 0.398438)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowHead);
export default __webpack_public_path__ + "static/media/yellow_head.4320ffcf734c15bd988d33bdda44ab54.svg";
export { ForwardRef as ReactComponent };